import { PageHero } from "@/components/site/PageParts";
import { Reveal } from "@/lib/motion";
import { Check, X } from "@phosphor-icons/react";

const DO = [
  "Be honest about who you are and what you want",
  "Treat every member with respect and courtesy",
  "Obtain clear, enthusiastic consent — always",
  "Keep interactions between consenting adults 18+",
  "Report content or behaviour that breaks the rules",
];

const DONT = [
  "Post or request illegal content of any kind",
  "Offer, advertise, or solicit paid sexual services",
  "Involve, depict, or target anyone under 18",
  "Harass, threaten, stalk, or intimidate members",
  "Share anyone's private information without consent",
  "Impersonate others or misrepresent your identity",
  "Post spam, scams, or commercial solicitations",
];

export default function CommunityRules() {
  return (
    <div data-testid="community-rules-page">
      <PageHero
        index="D/"
        overline="Community Rules"
        titleLines={["The rules that", <>keep us <span className="italic text-oxblood">human</span></>]}
        intro="Clear standards everyone agrees to. Break them and you'll be removed."
      />

      <section className="mx-auto max-w-[1400px] px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
        <Reveal>
          <div>
            <div className="flex items-center gap-4 mb-10">
              <span className="flex items-center justify-center w-12 h-12 border border-ink">
                <Check size={22} weight="light" />
              </span>
              <h2 className="font-serif text-3xl sm:text-4xl tracking-tight">Please do</h2>
            </div>
            <ul className="space-y-5">
              {DO.map((item, i) => (
                <li key={i} className="flex items-start gap-4 border-t border-line pt-5 text-lg">
                  <Check size={22} weight="light" className="text-ink shrink-0 mt-1" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div>
            <div className="flex items-center gap-4 mb-10">
              <span className="flex items-center justify-center w-12 h-12 border border-oxblood text-oxblood">
                <X size={22} weight="light" />
              </span>
              <h2 className="font-serif text-3xl sm:text-4xl tracking-tight text-oxblood">Never do</h2>
            </div>
            <ul className="space-y-5">
              {DONT.map((item, i) => (
                <li key={i} className="flex items-start gap-4 border-t border-line pt-5 text-lg">
                  <X size={22} weight="light" className="text-oxblood shrink-0 mt-1" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </section>

      <section className="border-t border-line">
        <div className="mx-auto max-w-[820px] px-6 md:px-12 py-16 md:py-20">
          <Reveal>
            <p className="font-serif text-2xl sm:text-3xl leading-[1.3] tracking-tight">
              Enforcement is <span className="italic text-oxblood">immediate.</span> Violations may result
              in content removal, account suspension, or permanent bans — and
              where the law requires, referral to the appropriate authorities.
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
